import React, {memo} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import {TextModel} from "models/Text"
import connect from "./connect"

interface FiltersMenuButtonProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    disableIcon: boolean
    openFiltersPanel: (event: React.MouseEvent<HTMLButtonElement>) => void
    text: TextModel
    allOtherFiltersSelected: boolean
}

const FiltersMenuButton = memo<FiltersMenuButtonProps>(function FiltersMenuButtonMemo({templating, ...props}) {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return <ComponentName {...props} />
})
FiltersMenuButton.displayName = "FiltersMenuButton"

export default connect(FiltersMenuButton)
